// extracted by mini-css-extract-plugin
module.exports = {"container":"label-text_container__3nwWD","label":"label-text_label__XoXNb","text":"label-text_text__2TX5m","labelTextDivider":"label-text_labelTextDivider__1Yhsb"};